import { MDBBtn, MDBIcon, MDBModalFooter } from 'mdb-react-ui-kit';
import React, { forwardRef } from 'react'
import { useTranslation } from 'react-i18next';

const RemoveExternal = forwardRef((props, ref) => {
  const { t, i18n } = useTranslation();
  async function removeThisUser(e) {
    e.preventDefault();
    props.setIsDeleteExt(true);
    props.onClose();

  }
  return (
    <>
      <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
        <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
        <span>{t("RemoveUserExtrnalNumbertxt")}</span>
      </div>
      {/* <MDBModalFooter>
          <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
            {t("cancel")}
          </MDBBtn>
          <MDBBtn onClick={(e) => {
            e.preventDefault();
            removeThisUser(e);
          }}>{t("remove")}</MDBBtn>
        </MDBModalFooter> */}
      <div style={{ display: "none" }}>
        <button ref={ref} onClick={(e) => removeThisUser(e)}>
          {t("remove")}</button>
      </div>
    </>
  )
});

export default RemoveExternal
